var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pb-3", attrs: { role: "main", id: "instructions" } },
    [
      _c("h1", [_vm._v(_vm._s(_vm._f("toUpperCase")(_vm.$t("Title"))))]),
      _vm._v(" "),
      _c("h2", [_vm._v("1. " + _vm._s(_vm.$t("Title_Organisation")))]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(_vm._s(_vm.$t("Organisation.Personnel.Title")))
      ]),
      _vm._v(" "),
      _c("div", [
        _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Array")))]),
        _vm._v(" "),
        _c("p", { staticClass: "question" }, [
          _vm._v(_vm._s(_vm.$t("Organisation.Personnel.RowHeader1")))
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            _vm._s(_vm.$t("Organisation.Personnel.RowHeader1_Instructions"))
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            _vm._s(_vm.$t("Organisation.Personnel.ColumnHeader3_Instructions"))
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "question" }, [
          _vm._v(_vm._s(_vm.$t("Organisation.Personnel.RowHeader2")))
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            _vm._s(_vm.$t("Organisation.Personnel.RowHeader2_Instructions"))
          )
        ])
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(_vm.$t("Organisation.PublicSector")) +
            " " +
            _vm._s(_vm.$t("Instructions.NoYes"))
        )
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(_vm.$t("Organisation.ServiceOperation")) +
            " " +
            _vm._s(_vm.$t("Instructions.NoYes"))
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(_vm._s(_vm.$t("Organisation.ServiceOperation_Instructions")))
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(_vm.$t("Organisation.OtherPublicAid")) +
            " " +
            _vm._s(_vm.$t("Instructions.NoYes"))
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(_vm._s(_vm.$t("Organisation.OtherPublicAid_Instructions")))
      ]),
      _vm._v(" "),
      _c("h2", [_vm._v("2. " + _vm._s(_vm.$t("Title_ProfitsAndExpenses")))]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(_vm._s(_vm.$t("ProfitsAndExpenses.Profits.Title")))
      ]),
      _vm._v(" "),
      _c("p", {
        domProps: {
          innerHTML: _vm._s(
            _vm.$t("ProfitsAndExpenses.Profits.Title_Instructions")
          )
        }
      }),
      _vm._v(" "),
      _c("div", [
        _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Array")))]),
        _vm._v(" "),
        _c("p", { staticClass: "question" }, [
          _vm._v(_vm._s(_vm.$t("ProfitsAndExpenses.Profits.ColumnHeader")))
        ]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [
            _vm._v(_vm._s(_vm.$t("ProfitsAndExpenses.Profits.SteaAid")))
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(_vm._s(_vm.$t("ProfitsAndExpenses.Profits.OtherAid")))
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(_vm._s(_vm.$t("ProfitsAndExpenses.Profits.Services")))
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(_vm._s(_vm.$t("ProfitsAndExpenses.Profits.FundRaising")))
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("ProfitsAndExpenses.Profits.Other")) +
                "\n        "
            ),
            _c("div", [
              _vm._v(
                _vm._s(_vm.$t("ProfitsAndExpenses.Profits.Other_Instructions"))
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(_vm._s(_vm.$t("ProfitsAndExpenses.Expenses.Title")))
      ]),
      _vm._v(" "),
      _c("p", {
        domProps: {
          innerHTML: _vm._s(
            _vm.$t("ProfitsAndExpenses.Expenses.Title_Instructions")
          )
        }
      }),
      _vm._v(" "),
      _c("div", [
        _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Array")))]),
        _vm._v(" "),
        _c("p", { staticClass: "question" }, [
          _vm._v(_vm._s(_vm.$t("ProfitsAndExpenses.Expenses.ColumnHeader")))
        ]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [
            _vm._v(_vm._s(_vm.$t("ProfitsAndExpenses.Expenses.SteaAid")))
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(_vm._s(_vm.$t("ProfitsAndExpenses.Expenses.OtherAid")))
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(_vm._s(_vm.$t("ProfitsAndExpenses.Expenses.Services")))
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(_vm._s(_vm.$t("ProfitsAndExpenses.Expenses.FundRaising")))
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("ProfitsAndExpenses.Expenses.Other")) +
                "\n        "
            ),
            _c("div", [
              _vm._v(
                _vm._s(_vm.$t("ProfitsAndExpenses.Expenses.Other_Instructions"))
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("h2", [_vm._v("3. " + _vm._s(_vm.$t("Title_BalanceSheet")))]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(_vm._s(_vm.$t("BalanceSheet.Table_Title")))
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(_vm._s(_vm.$t("BalanceSheet.Table_Title_Instructions")))
      ]),
      _vm._v(" "),
      _c("h2", [_vm._v("4. " + _vm._s(_vm.$t("Title_Administration")))]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(_vm.$t("Administration.RelatedOrganisations")) +
            " " +
            _vm._s(_vm.$t("Instructions.NoYes"))
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(_vm.$t("Administration.RelatedOrganisations_Instructions"))
        )
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Array")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(_vm._s(_vm.$t("Administration.Forms.Title")))
      ]),
      _vm._v(" "),
      _c("h2", [_vm._v("5. " + _vm._s(_vm.$t("Title_InternalMonitoring")))]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(_vm._s(_vm.$t("InternalMonitoring.Title")))
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(_vm._s(_vm.$t("InternalMonitoring.Title_Instructions")))
      ]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [_vm._v(_vm._s(_vm.$t("InternalMonitoring.Items.Item1")))]),
        _vm._v(" "),
        _c("li", [_vm._v(_vm._s(_vm.$t("InternalMonitoring.Items.Item2")))]),
        _vm._v(" "),
        _c("li", [_vm._v(_vm._s(_vm.$t("InternalMonitoring.Items.Item3")))]),
        _vm._v(" "),
        _c("li", [_vm._v(_vm._s(_vm.$t("InternalMonitoring.Items.Item4")))]),
        _vm._v(" "),
        _c("li", [_vm._v(_vm._s(_vm.$t("InternalMonitoring.Items.Item5")))]),
        _vm._v(" "),
        _c("li", [_vm._v(_vm._s(_vm.$t("InternalMonitoring.Items.Item6")))]),
        _vm._v(" "),
        _c("li", [_vm._v(_vm._s(_vm.$t("InternalMonitoring.Items.Item7")))]),
        _vm._v(" "),
        _c("li", [_vm._v(_vm._s(_vm.$t("InternalMonitoring.Items.Item8")))]),
        _vm._v(" "),
        _c("li", [_vm._v(_vm._s(_vm.$t("InternalMonitoring.Items.Item9")))])
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(_vm._s(_vm.$t("InternalMonitoring.RegulationsTitle")))
      ]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("InternalMonitoring.LiteralRegulations")) +
              "\n      "
          ),
          _c("div", [
            _vm._v(
              _vm._s(
                _vm.$t("InternalMonitoring.LiteralRegulations_Instructions")
              )
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(_vm._s(_vm.$t("InternalMonitoring.LiteralTravelInstructions")))
        ])
      ]),
      _vm._v(" "),
      _c("h2", [_vm._v("6. " + _vm._s(_vm.$t("Title_Attachments")))]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
      _vm._v(" "),
      _c("h3", [_vm._v(_vm._s(_vm.$t("Attachments.Title")) + ":")]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [_vm._v(_vm._s(_vm.$t("Attachments.Attachment1")))]),
        _vm._v(" "),
        _c("li", [_vm._v(_vm._s(_vm.$t("Attachments.Attachment2")))]),
        _vm._v(" "),
        _c("li", [_vm._v(_vm._s(_vm.$t("Attachments.Attachment3")))]),
        _vm._v(" "),
        _c("li", [_vm._v(_vm._s(_vm.$t("Attachments.Attachment4")))]),
        _vm._v(" "),
        _c("li", [_vm._v(_vm._s(_vm.$t("Attachments.Attachment5")))])
      ]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(_vm.$t("Attachments.AupNeeded")) +
            ". " +
            _vm._s(_vm.$t("Instructions.NoYes"))
        )
      ]),
      _vm._v(" "),
      _c("p", [_vm._v(_vm._s(_vm.$t("Attachments.AupNeeded_Instructions")))])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }